import { ProfileData } from "../../common/common.model";
import { rulesAndThresholds } from "./constants";

export class UserTableData {
  count: number;
  previous: any;
  next: any;
  results: UserTableEntity[];

  constructor(obj: any) {
    this.count = obj?.count;
    this.previous = obj?.previous;
    this.next = obj?.next;
    this.results = obj?.results?.map((res: any) => new UserTableEntity(res));
  }
}

class UserTableEntity {
  name: string;
  email: string;
  roles: [];
  id: string;
  powerUser: boolean;
  picture: string;
  profileDetails: {};

  constructor(obj: any) {
    this.name = obj?.given_name + " " + obj?.family_name;
    this.email = obj?.email;
    this.roles = obj?.roles;
    this.picture = obj?.picture;
    this.id = obj?.id;

    this.powerUser =
      obj?.roles?.filter((role: any) => role?.name === "admin").length !== 0;

    this.profileDetails = {
      name: this.name,
      image: this.picture,
      isPowerUser: this.powerUser,
    };
  }
}

export class PromptModel {
  id: string;
  rules: { name: string; count: number; unit: string }[];
  feature: string;
  category: string;
  displayName: string;
  isEnabled: boolean;
  updated_by: ProfileData;
  constructor(obj: any) {
    this.id = obj?.id || new Date().getTime().toString();
    this.rules = obj?.rules?.length > 0 ? obj?.sanitizer(obj?.rules) : [];
    this.feature = obj?.feature;
    this.category = obj?.category;
    this.displayName = obj?.display_name;
    this.isEnabled = obj?.is_enabled ?? true;
    this.updated_by = new ProfileData(obj?.updated_by);
  }
}

export class PromptModelForContractReview extends PromptModel {
  labelRules: {}[];
  threshold: {}[];
  constructor(obj: any) {
    super(obj);
    this.labelRules = rulesAndThresholds?.[obj?.display_name]?.rules;
    this.threshold = rulesAndThresholds?.[obj?.display_name]?.threshold;
  }
}
